import { CSSProperties } from 'react'
import Colors from 'modules/Colors'

interface RobotIconProps {
    className?: string
    style?: CSSProperties
    color?: string
    size?: number
    onClick?: () => void
}

const RobotIcon = ({
    className,
    style,
    color = Colors.purple,
    size = 24,
    onClick,
}: RobotIconProps) => {
    return (
        <svg
            className={className}
            style={style}
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
        >
            <path
                d="M10.8738 9.29689C10.8738 9.79453 10.4705 10.1979 9.97285 10.1979C9.47522 10.1979 9.07172 9.79453 9.07172 9.29689C9.07172 8.79926 9.47522 8.39575 9.97285 8.39575C10.4705 8.39575 10.8738 8.79926 10.8738 9.29689Z"
                fill={color}
            />
            <path
                d="M14.9286 9.29689C14.9286 9.79453 14.5251 10.1979 14.0275 10.1979C13.5298 10.1979 13.1265 9.79453 13.1265 9.29689C13.1265 8.79926 13.5298 8.39575 14.0275 8.39575C14.5251 8.39575 14.9286 8.79926 14.9286 9.29689Z"
                fill={color}
            />
            <path
                d="M8.39592 15.6043C7.6791 15.6043 6.99148 15.889 6.48455 16.396C5.97763 16.903 5.69275 17.5905 5.69275 18.3075C5.69275 18.6295 5.86449 18.9269 6.14324 19.0878C6.42215 19.2487 6.76565 19.2487 7.04437 19.0878C7.32313 18.9269 7.49486 18.6294 7.49486 18.3075C7.49486 18.0685 7.58977 17.8392 7.75885 17.6703C7.92776 17.5014 8.15702 17.4063 8.39586 17.4063H15.6043C15.8432 17.4063 16.0724 17.5014 16.2413 17.6703C16.4104 17.8392 16.5053 18.0685 16.5053 18.3075C16.5053 18.6295 16.6771 18.9269 16.9558 19.0878C17.2346 19.2487 17.5781 19.2487 17.857 19.0878C18.1357 18.9269 18.3074 18.6294 18.3074 18.3075C18.3074 17.5905 18.0226 16.903 17.5156 16.396C17.0087 15.889 16.3211 15.6043 15.6043 15.6043H12.901V13.8022H15.379C16.2154 13.8022 17.0175 13.4698 17.609 12.8784C18.2004 12.2869 18.5326 11.4848 18.5326 10.6483V7.9452C18.5326 7.10878 18.2005 6.30664 17.609 5.71516C17.0176 5.12368 16.2154 4.79153 15.379 4.79153H8.62103C7.78461 4.79153 6.98247 5.12371 6.39099 5.71516C5.79951 6.30661 5.46736 7.10878 5.46736 7.9452V10.6483C5.46736 11.4848 5.79954 12.2869 6.39099 12.8784C6.98243 13.4698 7.78461 13.8022 8.62103 13.8022H11.099V15.6043H8.39592ZM8.62125 12C8.26283 12 7.91903 11.8576 7.66557 11.6042C7.41211 11.3507 7.26959 11.0069 7.26959 10.6483V7.94521C7.26959 7.58679 7.41211 7.24298 7.66557 6.98952C7.91902 6.73607 8.26284 6.59371 8.62125 6.59371H15.3792C15.7376 6.59371 16.0814 6.73607 16.3349 6.98952C16.5883 7.24298 16.7309 7.5868 16.7309 7.94521V10.6483C16.7309 11.0069 16.5883 11.3507 16.3349 11.6042C16.0814 11.8576 15.7376 12 15.3792 12H8.62125Z"
                fill={color}
            />
        </svg>
    )
}

export default RobotIcon
